var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconParticipant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.6125C11.3792 2.6125 11.7547 2.68719 12.105 2.8323C12.4553 2.97741 12.7736 3.1901 13.0418 3.45823C13.3099 3.72636 13.5226 4.04467 13.6677 4.395C13.8128 4.74533 13.8875 5.12081 13.8875 5.5C13.8875 5.87919 13.8128 6.25467 13.6677 6.605C13.5226 6.95533 13.3099 7.27364 13.0418 7.54177C12.7736 7.8099 12.4553 8.02259 12.105 8.1677C11.7547 8.31281 11.3792 8.3875 11 8.3875C10.2342 8.3875 9.49974 8.08328 8.95823 7.54177C8.41672 7.00026 8.1125 6.26581 8.1125 5.5C8.1125 4.73419 8.41672 3.99974 8.95823 3.45823C9.49974 2.91672 10.2342 2.6125 11 2.6125ZM11 14.9875C15.0837 14.9875 19.3875 16.995 19.3875 17.875V19.3875H2.6125V17.875C2.6125 16.995 6.91625 14.9875 11 14.9875ZM11 0C7.96125 0 5.5 2.46125 5.5 5.5C5.5 8.53875 7.96125 11 11 11C14.0387 11 16.5 8.53875 16.5 5.5C16.5 2.46125 14.0387 0 11 0ZM11 12.375C7.32875 12.375 0 14.2175 0 17.875V22H22V17.875C22 14.2175 14.6713 12.375 11 12.375Z",
    fill: "#697F96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParticipant);
export default __webpack_public_path__ + "static/media/icon_participant.2ce7f6f57c2894c5bca9c0b7870f4b9e.svg";
export { ForwardRef as ReactComponent };